import { isProdEnv } from '../config';

export function getContinueParam() {
  const sp = new URLSearchParams(window.location.search);
  const raw = sp.get('continue');
  return raw ? decodeURIComponent(raw) : null;
}

// Keep this tight: only allow your OAuth authorize endpoint (and optionally your own dashboard)
export function isAllowedContinue(url) {
  try {
    const u = new URL(url);
    let approvedProtocol = 'https:';
    const allowedHosts = ['dashboard.limitless.tech'];
    if (!isProdEnv) {
      allowedHosts.push('localhost');
      approvedProtocol = 'http:';
    }
    // Require HTTPS and exact path if you want it even stricter:
    // const allowedPaths = ['/oauth2/authorize'];
    return (u.protocol === approvedProtocol) && allowedHosts.includes(u.hostname);
    // && allowedPaths.includes(u.pathname);
  } catch {
    return false;
  }
}
